module.exports = __webpack_public_path__ + "img/icon_charger_monitor_active.4a04a44c.png";